import React from 'react';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';

interface Props {
  cabinet: Cabinet;
}
const DimensionsItem = ({ cabinet }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center flex-grow flex-shrink">
      <DimensionStyled>
        {t('short.height')} {cabinet.height / 10}&nbsp;cm
      </DimensionStyled>
      <DimensionStyled>
        {t('short.width')} {cabinet.width / 10}&nbsp;cm
      </DimensionStyled>
      <DimensionStyled>
        {t('short.depth')} {cabinet.depth / 10}&nbsp;cm
      </DimensionStyled>
    </div>
  );
};

export default DimensionsItem;

const DimensionStyled = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 0.75rem;
  margin: 0;
  padding: 0;
  line-height: 1.25;
  color: ${p => p.theme.gray600};
`;
